import UtilityService from "../services/UtillityServices/UtilityService";

export default function useClassiConfigTable() {
    return [
      { 
        label: "Denominazione", 
        key: "denominazione",
        formatter: (value, row) => `${value} - ${row.corso.denominazione}`
      },
      { 
        key: 'data_inizio', 
        label: 'Data inizio', 
        formatter: (value) => value ? UtilityService.formatDate(value) : "Nessuna" 
      },
      { 
        key: 'data_fine', 
        label: 'Data fine', 
        formatter: (value) => value ? UtilityService.formatDate(value) : "Nessuna" 
      },
    ];
  }
  